import { render, staticRenderFns } from "./AddPoll.vue?vue&type=template&id=f18670de&scoped=true"
import script from "./AddPoll.vue?vue&type=script&lang=js"
export * from "./AddPoll.vue?vue&type=script&lang=js"
import style0 from "./AddPoll.vue?vue&type=style&index=0&id=f18670de&prod&scoped=true&lang=css"
import style1 from "./AddPoll.vue?vue&type=style&index=1&id=f18670de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18670de",
  null
  
)

export default component.exports